import React, { useState, useEffect, useCallback, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, fa0 } from '@fortawesome/free-solid-svg-icons'
import { MostraQuota, calculQuota } from '../quotes'
import Dropdown from '../../dropdown'
import { FormInputText, FormSelectRadio, FormSelectCicle, FormSelectNouAlumne, FormTextArea } from '../formelements'
import { useDropzone } from 'react-dropzone'
import { decode } from 'base-64'
import config from '../../../config'
const assignatures = require('../../../data/' + config.assignatures)

//DEBUG console.log("ASSIGNATURES ",assignatures)


const TriaAssignatures = (props) => {

  const llistaAssignatures = assignatures[props.curs.id]

  const llistaIDSInicialsMarcats = llistaAssignatures.flatMap( (moduls) => moduls.subjects.filter( s => s.SHOWONLY ).map( s => s.id))
  const [isCheckAll, setIsCheckAll] = useState([false, false, false]); // level = 0,1,2
  const [isCheck, setIsCheck] = useState(llistaIDSInicialsMarcats);
  const [only, setOnly] = useState(false);

  const resetCurs = (llista) => {

  setIsCheckAll([false, false, false]);
  setIsCheck(llista);
  props.setOrdreTriat([]);
  setOnly(false)

  }


  useEffect(() => {

    resetCurs(llistaIDSInicialsMarcats)

  },[props.curs.id]) // si canvia el curs, tornema inicialitzar assignatures triades


  const handleSelectAllLevel = (level) => {

    let newA = [...isCheckAll];

    newA[level] = !newA[level];

    setIsCheckAll(newA);

    let allList = []
    if(level === "A")
    {
        llistaAssignatures.map((assignatura) => assignatura.subjects.filter(item => item).map((subject) => { return allList.push(subject.id) }))

    }else {

      if (!isCheckAll[level]) {
        
        llistaAssignatures.map((assignatura) => assignatura.subjects.filter(item => item.level === level).map((subject) => { return allList.push(subject.id) }))
        
      }
    }

    setIsCheck(allList)
  };

  const handleClickOnSubject = (id, checked, XOR, ORD) => {

    // Si és assignatura única, forcem només aquesta i amagem les altres, o mostrem les altres al desmarcar.
    if (id === "ONLY") {

      if (checked) {
        setIsCheck([])
        setOnly(false)
        props.setRepetidor()
      }
      else
      {
        setIsCheck([id])
        setOnly(true)
        props.setRepetidor(1)
      }

      return
    }


    if (checked) { // eliminar entrada
      setIsCheck(isCheck.filter(item => item !== id));

      if( ORD ) {
          let isOrdDup = [...props.ordreTriat]

        if(isOrdDup[ORD]){
          let rowORD = isOrdDup[ORD]

          isOrdDup[ORD] = rowORD.filter(item => item !== id)

        props.setOrdreTriat(isOrdDup);
            //console.log("iOD",props.ordreTriat)
        }

      }



    }
    else { //  afegir nova entrada

      if (XOR) {  // si l'assignatura és "exclusiva" marca només aquesta eliminant la resta

        //console.log(id)

        
        if( XOR === true)
        { 
          setIsCheck([id])  // XOR true és assignatura unica de totes
        }
        else // XOR amb numero es un unic per grup númeric 1,2,3,4,...
        {
          let isCheckDup = []
          let sameXOR = []

          //console.log("XOR",XOR,id,checked)

            llistaAssignatures.map((assignatura) => 
              assignatura.subjects.filter(item => item.XOR === XOR ).map((subject) => { 

                //console.log(subject.id,subject.XOR," === ",XOR)
                return sameXOR.push(subject.id) 
              }))

          //console.log("sameXOR",sameXOR)
          isCheckDup = isCheck.filter(item => !sameXOR.some( item2 => item2 === item ) )

          setIsCheck([...isCheckDup, id])
        }

      } else if( ORD ) {

          let isCheckDup = [...isCheck]
          let isOrdDup = [...props.ordreTriat]

          
          /*
          llistaAssignatures.map((assignatura) => 
            assignatura.subjects.filter(item => item.ORD === ORD ).map((subject) => { 
              
              //console.log(subject.id,subject.XOR," === ",XOR)
                return sameORD.push(subject.id) 
                }))
              */

             setIsCheck([...isCheckDup, id])
             
             if(!isOrdDup[ORD]){
               isOrdDup[ORD] = []
              }
              
              isOrdDup[ORD].push(id)
              
              props.setOrdreTriat( isOrdDup )
            //console.log("iOD",isOrd)
        //console.log("isCheck same",isCheck,rowORD)


      } else {

        let isCheckDup = [...isCheck]

        setIsCheck([...isCheckDup, id])

      }
    }
    
  }



  const handleChangeReligio = (t) => {

    //const checkbox = refSubjectsTable.current?.querySelector('#RELIGIO');

    // valor de t: "1" religio o "2" valors   (valor inicial 0)
    props.setAuthReligio(t)

    resetCurs([])

    if(t === "1" ) { // religio seleccionada, cal marcar religio a les assignatures automaticament si no està ja marcat.

      if(!isCheck.includes("RELIGIO"))
      {
        llistaAssignatures.map( (m) => 
          { 
            if(m.id === "ESO1O" || m.id === "ESO2O" || m.id === "ESO3O") 
              m.subjects.map( (s) => { 
                  s.SHOWONLY = true 
                  if(s.id === "RELIGIO") handleClickOnSubject("RELIGIO", isCheck.includes("RELIGIO"), null, null)
                }
            )
          })
      }


    } else { // valor seleccionats desmarquem assignatura i la posem triable com a opcional (absurd??)


      if(isCheck.includes("RELIGIO"))
      {
        llistaAssignatures.map( (m) => 
          { 
            if(m.id === "ESO1O" || m.id === "ESO2O" || m.id === "ESO3O") 
              m.subjects.map( (s) => { 
                  s.SHOWONLY = false
                  if(s.id === "RELIGIO") handleClickOnSubject("RELIGIO", isCheck.includes("RELIGIO"), null, null)
                }
            )
          })
      }

      /*
      llistaAssignatures.map( (m) => m.subjects.map( (s) => { if(s.id === "RELIGIO") s.SHOWONLY = false }))
      if(isCheck.includes("RELIGIO"))
      {
        handleClickOnSubject("RELIGIO", isCheck.includes("RELIGIO"), null, null)
      }
        */

    }
  }
  //const refSubjectsTable = useRef();

  const handleClickOnModule = (module) => {

    let isCheckDup = [...isCheck]

    module.subjects.map((subject, index) => {

    //console.log("MODULE", isCheck.includes(subject.id), subject)

    if (isCheck.includes(subject.id)) {
      isCheckDup = (isCheckDup.filter(item => item !== subject.id));
    }
    else {

      isCheckDup = [...isCheckDup, subject.id]
    }

    setIsCheck(isCheckDup)

    } )

    
  }


  /**
   * Mostrar numero d'ordre en cas que hi hagi moduls amb ordre de preferencia
   * 
   */

  const preferenceOrderNumber = (ordreTriat,subject) => {

    //console.log("ORD",ordreTriat,subject.ORD)

    if (subject.ORD) {

    if (ordreTriat[subject.ORD]) {

      let icon

      switch (ordreTriat[subject.ORD].indexOf(subject.id) + 1) {
        case 1:
          icon = fa1; break;
        case 2:
          icon = fa2; break;
        case 3:
          icon = fa3; break;
        case 4:
          icon = fa4; break;
        case 5:
          icon = fa5; break;
        case 6:
          icon = fa6; break;
        case 7:
          icon = fa7; break;
        case 8:
          icon = fa8; break;
        case 9:
          icon = fa9; break;

        default: return (<FontAwesomeIcon icon={fa0} fixedWidth color="transparent" />)
      }

      return (<FontAwesomeIcon icon={icon} fixedWidth />)
    }
  }

    return (<FontAwesomeIcon icon={fa0} fixedWidth color="transparent" />)
  }
  
  
  
  useEffect((e) => {
    
    props.handleChange(isCheck)
    
  }, [isCheck])


  /* si només hi ha una assignatura, la marquem per defecte */
  useEffect((e) => {
  if(llistaAssignatures.length === 1 )
  {
    if (llistaAssignatures[0].subjects.length === 1) {
                                                             //checked XOR  ORD
       handleClickOnSubject(llistaAssignatures[0].subjects[0].id,false,true,false)
    }
  }

},[llistaAssignatures])
  

  let idx_torns = 0;
  if(props.nivellMax>0)  idx_torns = props.nivellMax - 1
  const torns = [{id: "M", value: "Matí"},{id: "T", value: "Tarda"}]

  let tornsenabled = props.curs.torns[idx_torns]

  // forcem al torn obligatori si ens ha vingut donat al moment de comprovar DNI
  if(props.tornObligatori) 
  { 
    tornsenabled = [props.tornObligatori]
  }

  //console.log("TORNS ENA",props.tornObligatori,tornsenabled)
  const errors = {}
  
  return (<div className="col col-12">

    <br/>

    <div id={props.id + '_CONTAINER'} className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs">



                                { config.autoritzacioReligioAbansTriarAssignatures && props.curs?.id.startsWith("ESOLOE") && (<>
                                <br/>
                                <br/>
                                      <div id="religio_CONTAINER" class="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs requadreAutoritzacioReligio" >
                                  <div class="t-Form-labelContainer">
                                        <div className="row">
                                          <div className="col col-12 ">
                                            <h4>
                                              Declaració sobre l'opció per la formació religiosa o valors
                                            </h4>

                                            <p>Aquesta elecció és vàlida durant tota l’etapa educativa d’ESO. En cas de canvi, en finalitzar el curs, s’ha de comunicar a la
                                              Secretaria del centre per a que aquest canvi tingui efectes el curs vinent.</p><br />


                                { props.curs?.id.startsWith("ESOLOE04") ?
                                          (<>
                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "1" ? true : false} onChange={(t) => { handleChangeReligio("1") }} required /> DESITGEM que el/la nostre/a fill/a rebi FORMACIÓ RELIGIOSA: CATÒLICA
                                            </label>

                                            <br />

                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "2" ? true : false} onChange={(t) => { handleChangeReligio("2") }} required /> DESITGEM que el/la nostre/a fill/a rebi ENSENYAMENT DE: VALORS
                                            </label>
                                            </>)
                                            :
                                          (<>
                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "1" ? true : false} onChange={(t) => { handleChangeReligio("1") }} required /> DESITGEM que el/la nostre/a fill/a rebi FORMACIÓ RELIGIOSA: CATÒLICA
                                            </label>

                                            <br />

                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "0" ? true : false} onChange={(t) => { handleChangeReligio("0") }} required /> <b>NO</b> DESITGEM que el/la nostre/a fill/a rebi FORMACIO RELIGIOSA: CATÒLICA
                                            </label>
                                            </>)
                                            }

                                            <span id="auhtReligio_ERROR" className="a-Form-error">{errors.authReligio}</span>

                                          </div>
                                        </div>

                                      </div>
                                      </div>
                                    <br />
                                </>)}



{ (!config.autoritzacioReligioAbansTriarAssignatures || !props.curs.id.startsWith("ESO") || props.authReligio ) && (<>

      <div className="t-Form-labelContainer">
        <label for={props.id} id={props.id + '_LABEL'} className="t-Form-label">Tria d'assignatures</label>

        {( props.curs.id === "ESOLOE01" && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["ESOLOE01"] && config.textTriarAssignatures["ESOLOE01"] ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["ESOLOE01"] }} /></>)}
        {( props.curs.id.startsWith("ESO") && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["ESO"] ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["ESO"] }} /></>)}
        {( props.curs.id.startsWith("BATX") && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["BATX"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["BATX"] }} /></>)}

        { props.nouAlumne ? (<>
        {( props.cicle === "CFGM" && llistaAssignatures.length > 1 && config.textTriarAssignaturesNous?.["CFGM"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignaturesNous["CFGM"] }} /></>)}
        {( props.cicle === "CFGS" && llistaAssignatures.length > 1 && config.textTriarAssignaturesNous?.["CFGS"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignaturesNous["CFGS"] }} /></>)}
        </>)
        :(<>
        {( props.cicle === "CFGM" && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["CFGM"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["CFGM"] }} /></>)}
        {( props.cicle === "CFGS" && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["CFGS"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["CFGS"] }} /></>)}
        </>)}

      </div>

       <br/>

      <div className="t-Form-inputContainer">

        <div className="t-Form-itemWrapper">

          <div className="col col-3 ">
            {(llistaAssignatures.length > 1 && config.mostraTorns ) && (
              <FormSelectRadio elements={torns} enabledelements={tornsenabled} col=" col-12" name="torn" value={props.torn} label="Torn" handleChange={props.handleCanviTorn} />
            )}
          </div>

          <div className="col col-1 "> &nbsp;</div>

            { (llistaAssignatures.length > 1 && 
                    ( !props.curs.id.startsWith("ESO") 
                    && !props.curs.id.startsWith("BATX") 
                    && !props.curs.id.startsWith("PFI")  )) 
              && (
                <div className="col col-4 ">
                <label className="t-Form-label">Tria totes les assignatures del curs:</label>
                <table border="0" className="subjectsTable">

                  <tr className="level_1" onClick={() => handleSelectAllLevel(1)}>
                    <td>
                      <label className="t-Form-label">1r curs tot el curs</label>
                    </td>
                  </tr>

                  <tr className="level_2" onClick={() => handleSelectAllLevel(2)}>
                    <td>
                      <label className="t-Form-label">2n curs tot el curs</label>
                    </td>
                  </tr>


                  { props.curs.curs3x2 &&(<tr className="level_all" onClick={() => handleSelectAllLevel("A")}>
                    <td>
                      <label className="t-Form-label">3x2 (doble titulació)</label>
                    </td>
                  </tr>)}
                </table>
              </div>
              )}



          <table border="0" className="subjectsTable">

            {/*
            <tr>
                <th></th>
                <th className="">Codi</th>
                <th className="">Assignatura</th>
                <th className="">Hores</th>
                <th className="">Codi curs</th>
            </tr>
*/}

            {llistaAssignatures.map((module, index) =>
            (
              <React.Fragment>

                  {
                     (module.name.length > 0) && (
                <tr style={{ display: (only) ? "none" : "table-row" }} >
                  <th colspan="1">
                  </th>
                  <th colspan="2">
                     { 
                     ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") ) ?
                      (<label for={module.id} id={module.id + '_LABEL'} className="t-Form-label"><b>{module.name}</b></label>)
                      :
                      (<label for={module.id} id={module.id + '_LABEL'} className="t-Form-label" onClick={() => handleClickOnModule(module)}><b>{module.name}</b></label>) 
                     }
                  </th>
                </tr>
                    )
                  }

                {module.subjects.map((subject, index) =>
                (<tr key={index} className={'level_' + subject.level} style={{ display: (only && subject.id !== "ONLY") ? "none" : "table-row", backgroundColor: ( subject.id === "ONLY" || subject.SHOWONLY) ? "lightgrey" : null, cursor: subject.SHOWONLY ? "default" : "pointer" }} onClick={() => { if(!subject.SHOWONLY){ handleClickOnSubject(subject.id, isCheck.includes(subject.id), subject.XOR, subject.ORD )} }}>

                  <td><input type="checkbox" id={subject.id} name="familia" value={subject.id} checked={isCheck.includes(subject.id) /* || subject.SHOWONLY */ } disabled={subject.SHOWONLY ? true : false } readOnly />
                  
                  &nbsp;&nbsp;{ (<h>{ preferenceOrderNumber(props.ordreTriat,subject)}</h>)}
                  </td>
                  {/* subject.preu !== undefined && (<td for={theme.id} id={theme.id + '_LABEL'} className=""><i>{subject.preu}€</i></td>)*/}
                  {/*<td for={theme.id} id={theme.id + '_LABEL'} className="">{subject.id.split(".").pop()}</td>*/}
                  <td for={module.id} id={module.id + '_LABEL'} className="">{subject.name}</td>
                  {/*<td for={theme.id} id={theme.id + '_LABEL'} className="">{subject.hours}</td>
                  <td for={theme.id} id={theme.id + '_LABEL'} className="">{subject.assign}</td>*/}
                </tr>))}
              </React.Fragment>
            ))}

          </table>

        </div>

        <span id="{props.id}_ERROR" className="a-Form-error"></span>

      </div>

      </>)}

    </div>


  </div>)


}




/*
 Desplegable que permet triar quin cicle / tipus de curs volem cursar
*/
const TriaCurs = (props) => {

  let fam = props.families[props.cicle].families.filter(f => f.id === props.familia).pop();

  // si el curs te l'atribut nouAlumne només els mostra als que tinguin el mateix valor T/F, mostra a tothom si no està posat
  let cursos = fam.cursos.filter( f => { 
  if( f?.nouAlumne === undefined ) return f 
    else 
      if( f.nouAlumne === props.nouAlumne ) return f 
   })

  //console.log("CURSOS",cursos)

  return (<FormSelectRadio elements={cursos} col=" col-12" name="curs" cursObligatori={props.cursObligatori} value={props.curs?.id} label={props.label} handleChange={props.handleChange} />)

}


/*
 Desplegable que mostra les families de cada cicle
*/
const SeleccionaCicleFamilia = (props) => {

  let col = 3

  if( props.families[props.cicle].families.length > 4 )
  {
     col = 2
  }
  else if( props.families[props.cicle].families.length < 3 )
  {
     col = 4
  }

  return (<FormSelectRadio elements={props.families[props.cicle].families} col={" col-" + col } name="familia" value={props.familia} label={props.label} handleChange={props.handleChange} />)

}



/*** FUNCIO PRINCIPAL ***/

export function EnrolmentFormStudies(props) {

//DEBUG console.log("FAMILIES XXX ",config.families,families)

  const [errors, setErrors] = useState({});

  const [cicle, setCicle] = useState();
  const [nouAlumne, setNouAlumne] = useState(config.noPreguntarSiEsNouAlumne === true ? false : undefined);
  const [nPreinscripcio, setNPreinscripcio] = useState('');
  const [titolAccesFile, setTitolAccesFile] = useState()
  const [notesAccesFile, setNotesAccesFile] = useState()
  const [familia, setFamilia] = useState();
  const [curs, setCurs] = useState();
  const [quota, setQuota] = useState();
  const [observacionsMatricula, setObservacionsMatricula] = useState();
  const [dadesInscripcioOpen, setDadesInscripcioOpen] = useState(true);
  const [dadesQuotaOpen, setDadesQuotaOpen] = useState(true);
  const [assignatures, setAssignatures] = useState([]);
  const [ordreTriat, setOrdreTriat] = useState([]);
  const [torn, setTorn] = useState('M')
  const [repetidor , setRepetidor ] = useState()
  const [materials, setMaterials] = useState([])
  const [bonificacio, setBonificacio] = useState([])
  const [dosTerminis, setDosTerminis] = useState(false)
  const [justificantPagamentFile, setJustificantPagamentFile] = useState()
  const [bonificacioFile, setBonificacioFile] = useState()
  //const [notesCursAnteriorFile, setNotesCursAnteriorFile] = useState()
  const [nivellMax, setNivellMax] = useState(0);
  const [families, setFamilies] = useState([]);

  const [dadesEstudis, setDadesEstudis] = useState({validat: false});

  const [authReligio, setAuthReligio] = useState();

  const dataNaixement = props.dadesPersonals?.dataNaixement;
  const iddocument = props.dadesPersonals?.iddocument;
  const becat = props.dadesPersonals?.becat;
  const sexe = props.dadesPersonals?.sexe;
  const germansAlCentre = props.dadesPersonals?.germansAlCentre; //només per JM

  /* carrega families des de l'API */
  useEffect((e) => {
  fetch(config.apiURL,{ method:'POST', 
    body: JSON.stringify({ cid: config.cid, act: 'getFam' }),
    headers: new Headers({'Content-Type': 'application/json' })})
    .then(res => res.json())
    .then(data => setFamilies(JSON.parse(decode(data.f))))
    .catch((err) => { console.log(err) })
  },[])


  const  inValidaEstudis = () => {
    handleDadesEstudis(false)
  }

  const validaEstudis = (e) => {
    e.preventDefault()
  
    let error = {}
  
    error.quota = quota ? null : "Error: quota de pagament no calculada"

    //només obligatori pels nous i de cicles
    if(nouAlumne && cicle.startsWith('BATX'))
    {
      //error.titolAccesFile = titolAccesFile ? null : "Cal adjuntar títol pel qual s'accedeix"
      //handleErrors("titolAccesFile",error.titolAccesFile);

      if(config.notesAcces)
      {
        error.notesAccesFile = notesAccesFile ? null : "Cal adjuntar notes del curs anterior"
        handleErrors("notesAccesFile",error.notesAccesFile);
      }
    }
    else
    {
      // TODO  Caldria passar valor al quotes.xxx.js
      //error.repetidor = repetidor !== undefined ? null : "Cal indicar una opció"
      //handleErrors("repetidor",error.repetidor);
    }

    if( config.pagamentTPV && quota.total>0 )
    {
      /*error.justificantPagamentFile = justificantPagamentFile ? null : "Cal adjuntar justificant de pagament"
      handleErrors("justificantPagamentFile",error.justificantPagamentFile);*/
    }

    if( config.pagamentTransferencia && quota.total>0 )
    {
      error.justificantPagamentFile = justificantPagamentFile ? null : "Cal adjuntar justificant de pagament"
      handleErrors("justificantPagamentFile",error.justificantPagamentFile);
    }

    if(quota.bonificacio>0 && bonificacio !== "dona")
    {
      error.bonificacioFile = bonificacioFile ? null : "Cal adjuntar justificant de bonificació / exempció "
      handleErrors("bonificacioFile",error.bonificacioFile);
    }

    /*
    if( nouAlumne && nivellMax === 2 )
    {
      error.notesCursAnteriorFile = notesCursAnteriorFile ? null : "Cal adjuntar les notes del curs anterior"
      handleErrors("notesCursAnteriorFile",error.notesCursAnteriorFile);
    }
    */

    //console.log("REP 1",config.repetidor,nouAlumne)
    if ( config.repetidor && !nouAlumne )
    {
    //console.log("REP 2",repetidor)
      error.repetidor = repetidor !== null ? null : "Cal indicar si promocioneu o sou repetidors"

    //console.log("REP 3",repetidor)
      handleErrors("repetidor",error.repetidor);
    }


    if( config.repetidorsNoPodenAgafarAssignaturesDe2n )
    {
      if( repetidor === 1 && nivellMax === 2 )
      {
        error.repetidorsNoPodenAgafarAssignaturesDe2n = "Si repeteixes 1r no pots agafar assignatures de 2n"
        handleErrors("repetidosNoPoenAgafarAssignaturesDe2n",error.repetidorsNoPodenAgafarAssignaturesDe2n);
      }

    }


    
    setErrors(error)

    let noError = true;

    if(!config.develop) // bypass errors if develop == true
    {
     Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
    }

    handleDadesEstudis(noError)
  
    if(noError)
    {
        setDadesInscripcioOpen(false)
        setDadesQuotaOpen(false)
    }
  
    return false;
  }


  // canvis en dades quota, recaulculem
  useEffect(() => {

  //console.log("ini2",sexe,germansAlCentre,props.dadesPersonals)

    setQuota(calculQuota(curs,assignatures,dataNaixement,repetidor,setRepetidor,materials,setMaterials,setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre ));
    inValidaEstudis()

  }, [assignatures,repetidor,dataNaixement,curs,materials, bonificacio, torn, becat, sexe, nouAlumne, germansAlCentre]);

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  const handleFileError = (e,msg) => {
    let err  = {...errors}
    err[e] = msg 
    setErrors(err)
  }

function DropZone(props) {
  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files

    handleErrors(props.id, { justificantPagamentFile: null })

    let file = acceptedFiles[0];

      const MAXSIZE = 4
      if (file.size > MAXSIZE * 1024 * 1024 ) {
        props.handleFileError("Arxiu massa gran màxim " + MAXSIZE + "MB")
        file = undefined
        props.onChange() // buidem file al no ser correcte
      }

    if (file) {

       /*if (!/^image/.test(file.type)) {
          setIDDocumentFile(null)
          return handleErrors(props.id, { [props.id]: "Tipus d'arxiu no vàlid" })
        }*/

        //console.log("FT",file.type);
        if (!/^image\/png/.test(file.type) && !/^image\/jpeg/.test(file.type)) {
          file = undefined
          props.onChange() // buidem file al no ser correcte
          props.handleFileError("Tipus d'arxiu no vàlid. S'accepten imatges JPG o PNG.")
          return false
        }

        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          // Do whatever you want with the file contents
          const fileContent = reader.result
          //console.log("BIN", fileContent)

          props.onChange({file: file, fileContent: fileContent})

          //console.log(acceptedFiles[0].name) // size type
        }
        reader.readAsDataURL(file)
    }

  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div className="col">
      <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id={props.id + '_CONTAINER'}>
        <div className="t-Form-labelContainer">
          <label for={props.id} id={props.id + '_LABEL'}
            className="t-Form-label">{props.label} <small>{props.labelSmall}</small></label>
        </div>
        <div className="t-Form-inputContainer">
          <div className="t-Form-itemWrapper">
            <div {...getRootProps()} style={{ width: '100%' }}>
              <input {...getInputProps()} />
              {isDragActive && <p>Drop the files here ...</p>}
              {!isDragActive && (<div className="dropZone"> {props.file?.file ? props.file.file.name : props.labelDrop} </div>)}
            </div>
          </div>
          <span id={props.id + '_ERROR'} className="a-Form-error">{props.error}</span>
        </div>
      </div>
    </div>)
}

  const handleCanviCicle = (t) => {
    setCicle(t.target.value)
    setFamilia(null)
    setCurs(null)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviNouAlumne = (t) => {
    setNouAlumne(t.target.value === "1" ? true : false)
    setNPreinscripcio('')
    setCicle(null)
    setFamilia(null)
    setCurs(null)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviFamilia = (f) => {
    setFamilia(f)
    setCurs(null)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviCurs = (c) => {
    let fam = families[cicle].families.filter(f => f.id === familia).pop();
    let cur = fam.cursos.filter(fc => fc.id === c).pop();
    setCurs(cur)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviAssignatures = (a) => {
    setAssignatures(a)
  }

  const handleCanviTorn = (t) => {
    setTorn(t)
  }

  const handleCanviNivellMax= (n) => {
    setNivellMax(n)
  }


  const toggleDadesInscripcioOpen = () => {
    setDadesInscripcioOpen(!dadesInscripcioOpen)
  }

  const toggleDadesQuotaOpen = () => {
    setDadesQuotaOpen(!dadesQuotaOpen)
  }

  const handleDadesEstudis = (noError) => {

    let d = {
     "validat": noError,
    /* DADES ESTUDIS */

      "cicle": cicle,
      "nouAlumne": nouAlumne,
      "nPreinscripcio": nPreinscripcio,
      "titolAccesFile": titolAccesFile,
      "notesAccesFile": notesAccesFile,
      "familia": familia,
      "curs": curs,
      "quota": quota,
      "observacionsMatricula": observacionsMatricula,
      "dadesInscripcioOpen": dadesInscripcioOpen,
      "dadesQuotaOpen": dadesQuotaOpen,
      "assignatures": assignatures,
      "ordreTriat": ordreTriat,
      "torn": torn,
      "repetidor": repetidor,
      "materials": materials,
      "bonificacions": bonificacio,
      "dosTerminis": dosTerminis,
      "justificantPagamentFile": justificantPagamentFile,
      "bonificacionsFile": bonificacioFile,
      //"notesCursAnteriorFile": notesCursAnteriorFile,
      "nivellMax": nivellMax,
    }

     // console.log("d0",d)
    if(config.autoritzacioReligioAbansTriarAssignatures) d.authReligio =  authReligio
      //console.log("d1",d)
  
      setDadesEstudis(d)
      props.handleDadesEstudis(d)
    }

  /*
  recompte d'assignatures amb XOR i ORD  per saber quantes necessitem com a mínim per mostrar ja quota 
  */
 function countNeededSubjects(data) {
   let ordGroupCount = 0;
   let ordSubjectCount = 0;
   let showOnlyCount = 0;
   let optativesESO = 0
   
   data.forEach(group => {
     let groupHasORD = false
     let groupHasXOR = false
     let subjectsCount = 0

     group.subjects.forEach(subject => {

       if ('ORD' in subject) {
         ordSubjectCount++;
          //console.log("ORD",subject.name)
         groupHasORD = true
         if (subject.id.startsWith("ESO1O")) optativesESO++

        } else if ('XOR' in subject) {
          //console.log("XOR",subject.name)
         groupHasXOR = true
        /*} else if ('SHOWONLY' in subject) {
          console.log("SHOWONLY",subject.name)
          showOnlyCount++*/
        }else{
          //console.log("NORMAL",subject.name,subject.id)
          subjectsCount++
        }



      });
      
      if (groupHasORD) {
        //ordGroupCount++
      } else if (groupHasXOR) {
        ordGroupCount++
      } else {
        ordSubjectCount += subjectsCount
      }

    });

    let total = ordGroupCount + ordSubjectCount

    // si han triat religio es bloquegen resta d'optatives per tant no cal comptar-les
   if (config.autoritzacioReligioAbansTriarAssignatures) {
     if (authReligio === "1" ) {
       total -= optativesESO 
      //console.log("aR",total,optativesESO)
     }
   }

    return  total;
  }




  // condicions per mostrar families 
  let mostraFamilies = (cicle && nouAlumne !== undefined) ? true : false
  let mostraCicle = (cicle && nouAlumne !== undefined && ( ( nouAlumne && nPreinscripcio) || !nouAlumne )  ) ? true : false

  // condicions per mostrar cicles
  //let mostraSelectCicle = (nouAlumne !== undefined && (nouAlumne === false || (nouAlumne === true && ( nPreinscripcio.length > 0 && titolAccesFile )))) ? true : false

  let potMatricularCicles = (nouAlumne !== undefined && (nouAlumne === false || (nouAlumne === true && ( nPreinscripcio.length > 0 && titolAccesFile && ( notesAccesFile || !config.notesAcces ) )))) ? true : false
  let mostraSelectCicle = (nouAlumne !== undefined ) ? true : false

  const llistatCompletAssignatures = require('../../../data/' + config.assignatures)
  let assignaturesCurs = []
  let assignaturesMinimesNecessaries = 1
  let assignaturesTotalsNecessaries = 1
  
  if(curs)
  {
    assignaturesCurs = llistatCompletAssignatures[curs.id]

    assignaturesTotalsNecessaries = countNeededSubjects(assignaturesCurs); 

    //console.log("CURS",assignaturesCurs.length,countNeededSubjects(assignaturesCurs),assignaturesCurs)

    if(curs.id.startsWith("ESO")) assignaturesMinimesNecessaries = countNeededSubjects(assignaturesCurs); 
                             //assignaturesCurs.length //minim una per modul indicat (normalment 1)

     // Si son repetidors amb una assinatura ja és suficient(JM)
    if(curs.id.startsWith("BATX") && (!familia.endsWith("REPETIDORS") && !config.pattern_batx_nocturn.test(curs.id))) assignaturesMinimesNecessaries = countNeededSubjects(assignaturesCurs); 
  }


  return (
            <div className="container">
              <div className="row">
                <div className="col col-12 ">
                  <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">

                    <div className="t-Region-header">
                      <div className="t-Region-headerItems  t-Region-headerItems--controls">
                        <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={() => toggleDadesInscripcioOpen()}>
                          {dadesInscripcioOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                          {!dadesInscripcioOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                        </button>
                      </div>
                      <div className="t-Region-headerItems t-Region-headerItems--title">
                        <h2 className="t-Region-title a-Collapsible-heading">Inscripció</h2>
                      </div>
                      <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
                    </div>

                    <Dropdown open={dadesInscripcioOpen}>
                      <div className="t-Region-bodyWrap">
                        <div className="t-Region-body a-Collapsible-content">

                          <div className="container">
                            <div className="row">
                              <div className="col col-12 ">
                                <div
                                  className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                                  <div className="t-Region-bodyWrap">
                                    <div className="t-Region-body">
                                      <div className="container">
                                        <div className="row">


                                          { config.noPreguntarSiEsNouAlumne === false && (<FormSelectNouAlumne id="nouAlumne" label={config.textAlumneNouAlCentre} labelSub={config.textAlumneNouAlCentreSub} nouAlumne={nouAlumne} handleChange={handleCanviNouAlumne} />)}


                                          <br/>

                                          {mostraSelectCicle && (<FormSelectCicle 
                                                                  id="cicle" 
                                                                  label="Nivell d'estudis pels que fas la matrícula:" 
                                                                  potMatricularCicles={potMatricularCicles} 
                                                                  nouAlumne={nouAlumne} 
                                                                  cicle={cicle} 
                                                                  handleChange={handleCanviCicle} 
                                                                  families={families}
                                                                  iddocument={props.dadesPersonals?.iddocument}
                                                                  />)}




                                          {nouAlumne && mostraFamilies && (
                                          <>
                                          <br/>
                                            <FormInputText id="ninscripcio" col="col-4" name="inscripcio" label="nº de preinscripció*" value={nPreinscripcio} onChange={setNPreinscripcio} size="20" maxLength="20" />



                                          {cicle === "BATX" &&
                                            (<> 
                                            <div className="col col-2">
                                              <DropZone id="titolAccesFile" 
                                              file={titolAccesFile} 
                                              onChange={setTitolAccesFile} 
                                              label="Adjuntar títol pel qual accedeix" 
                                              labelDrop="adjuntar títol d'accés" 
                                              error={errors.titolAccesFile} 
                                              handleFileError={ (msg) =>handleFileError('titolAccesFile',msg) }  />
                                            </div>

                                            { config.notesAcces && (
                                              <div className="col col-2">
                                              <DropZone id="notesAccesFile" 
                                              file={notesAccesFile} 
                                              onChange={setNotesAccesFile} 
                                              label="Adjuntar notes del curs anterior" 
                                              labelDrop="adjuntar notes" 
                                              error={errors.notesAccesFile} 
                                              handleFileError={ (msg) =>handleFileError('notesAccesFile',msg) }  />
                                            </div>)}


                                              <div className="row">

                                                <div className="col col-4">
                                                  &nbsp;
                                                </div>
                                              </div>
                                              <div className="row">
                                                <div className="col col-8">
                                                  <div class="t-Form-labelContainer">
                                                      <label className="t-Form-label">
                                                        <small>
                                                            Cal proporcionar número de preinscripció, adjuntar títol pel qual s'accedeix i les notes del curs anterior per poder proseguir amb la matrícula de <b>Batxillerat</b>
                                                        </small>
                                                      </label>
                                                  </div>
                                                </div>
                                              </div>

                                            </>)
                                          }

                                          {cicle === "ESO" &&
                                            (<> 
                                      <div className="row">

                                        <div className="col col-4">
                                          &nbsp;
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col col-8">
                                          <div class="t-Form-labelContainer">
                                              <label className="t-Form-label">
                                                <small>
                                                  Cal proporcionar número de preinscripció.
                                                </small>
                                              </label>
                                          </div>
                                        </div>
                                      </div>

                                            </>)
                                          }





                                          <br/>
                                            </>
                                          )}










                                          {mostraFamilies && mostraCicle && cicle && (<SeleccionaCicleFamilia 
                                                                        label="Família" 
                                                                        cicle={cicle} 
                                                                        families={families} 
                                                                        familia={familia} 
                                                                        handleChange={handleCanviFamilia} 
                                                                        />)}

                                          {mostraFamilies && familia && (<TriaCurs cicle={cicle} 
                                                                                   familia={familia} 
                                                                                   families={families}
                                                                                   nouAlumne={nouAlumne}
                                                                                   curs={curs} 
                                                                                   cursObligatori={props.dadesPersonals?.cursObligatori} 
                                                                                   label="Tria curs (tria el curs que faràs)" 
                                                                                   handleChange={handleCanviCurs} />)}




                                          {mostraFamilies && familia && curs && (<TriaAssignatures curs={curs} handleChange={handleCanviAssignatures}
                                                                                                   cicle={cicle} 
                                                                                                   nouAlumne={nouAlumne}
                                                                                                   torn={torn} handleCanviTorn={handleCanviTorn} 
                                                                                                   nivellMax={nivellMax} handleCanviNivellMax={handleCanviNivellMax} 
                                                                                                   tornObligatori={props.dadesPersonals?.tornObligatori}
                                                                                                   repetidor={repetidor} setRepetidor={setRepetidor}
                                                                                                   ordreTriat={ordreTriat} setOrdreTriat={setOrdreTriat}
                                                                                                   authReligio={authReligio} setAuthReligio={setAuthReligio}
                                                                                                   />)}

  
                                                                                {/* PF: esperem a que hagin marcat autoritzacio previa per mostrar comentaris*/}
                                          {mostraFamilies && familia && curs && (!config.autoritzacioReligioAbansTriarAssignatures || !curs.id.startsWith("ESO") || authReligio > 0 ) && (<FormTextArea 
                                                                                    id="observacionsMatricula" 
                                                                                    name="observacionsMatricula"
                                                                                    label="Observacions tria d'assignatures"
                                                                                    placeHolder={ (config.batxilleratNocturnText && config.pattern_batx_nocturn.test(curs.id)) ? config.batxilleratNocturnText : ""}
                                                                                    obligatori={false}
                                                                                    rows="5"
                                                                                    cols="80"
                                                                                    maxLength="1000"
                                                                                    value={observacionsMatricula}
                                                                                    onChange={setObservacionsMatricula}
                                                                                    error={errors.observacionsMatricula}
                                                                                    />)}

                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>

                          </div>

                        </div>
                      </div>
                    </Dropdown>

                  </div>
                </div>
              </div>


      {
        /* s'ha d'haver triat minim una assignatura per mostrar quota */
        /* sense condicions si no es ESO o BATX */
        /* amb condicions de triar totes les modals i optatives si es ESO o BATXILLERAT */
        /*
        ( assignatures.length > 0
          &&
          (
            ((!curs.id.startsWith("ESO") && !curs.id.startsWith("BATX")))
            ||
            ((curs.id.startsWith("ESO") || curs.id.startsWith("BATX")) && assignatures.length === assignaturesCurs.length))
        )*/
        assignatures.length >= assignaturesMinimesNecessaries
        && (
                <div className="container">
                  <div className="row">
                    <div className="col col-12 ">
                      <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">

                        <div className="t-Region-header">
                          <div className="t-Region-headerItems  t-Region-headerItems--controls">
                            <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={() => toggleDadesQuotaOpen()}>
                              {dadesQuotaOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                              {!dadesQuotaOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                            </button>
                          </div>
                          <div className="t-Region-headerItems t-Region-headerItems--title">
                            <h2 className="t-Region-title a-Collapsible-heading">Quota d'inscripció</h2>
                          </div>
                          <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
                        </div>


                        <Dropdown open={dadesQuotaOpen}>
                        <div className="t-Region-bodyWrap">
                          <div className="t-Region-body a-Collapsible-content">

                            <div className="container">
                              <div className="row">
                                <div className="col col-12 ">
                                  <MostraQuota curs={curs} 
                                               cicle={cicle}
                                               quota={quota} 
                                               assignatures={assignatures} 
                                               nouAlumne={nouAlumne}

                                               repetidor={repetidor} setRepetidor={setRepetidor} error={errors}
                                               materials={materials} setMaterials={setMaterials} 
                                               bonificacions={bonificacio} setBonificacions={setBonificacio} 
                                               dosTerminis={dosTerminis} setDosTerminis={setDosTerminis} 

                                               nivellMax={nivellMax}

                                               iddocument={iddocument}
                                               becat={becat}
                                               sexe={sexe}
                                               germansAlCentre={germansAlCentre}

                                               assignaturesMinimesNecessaries={assignaturesMinimesNecessaries}
                                               assignaturesTotalsNecessaries={assignaturesTotalsNecessaries}
                                               />
                                </div>

                          <div className="row" style={{ paddingTop: '2rem'}}>


                            { config.pagamentTransferencia && ( quota?.total > 0 && (
                              <div className="col col-4">
                                <DropZone id="justificantPagamentFile" 
                                file={justificantPagamentFile} 
                                onChange={setJustificantPagamentFile} 
                                label="Adjuntar justificant del pagament*" 
                                labelDrop="adjuntar justificant" 
                                error={errors.justificantPagamentFile} 
                                handleFileError={ (msg) =>handleFileError('justificantPagamentFile',msg) }  />
                              </div>))}

                            { (quota?.bonificacio > 0 && bonificacio !== "dona") &&
                             ( <div className="col col-4">
                                <DropZone id="bonificacionsFile" file={bonificacioFile} onChange={setBonificacioFile} label="Adjuntar justificant del bonificació/exempció*" labelDrop="adjuntar justificant" error={errors.bonificacioFile} 
                                handleFileError={ (msg) =>handleFileError('bonificacionsFile',msg) }  />
                              </div>)}

                            { /*nouAlumne && ( nivellMax === 2 && (
                              <div className="col col-4">
                                <DropZone id="notesCursAnteriorFile" file={notesCursAnteriorFile} onChange={setNotesCursAnteriorFile} label="Per alumnes nous que vulguin UF de 2n curs cal adjuntar notes curs anterior*" labelDrop="adjuntar notes curs anterior" error={errors.notesCursAnteriorFile} 
                                handleFileError={ (msg) =>handleFileError('notesCursAnteriorFile',msg) }  />
                              </div>))*/}


                          </div>
                              </div>


                            </div>

                          </div>
                        </div>

                          <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaEstudis} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                        </Dropdown>

                      </div>

                    </div>
                  </div>

                </div>)
              }
            </div>


  );
}